import * as React from "react";
import axios from "axios";
import * as Logger from "./Logger";
import { def } from "./Default"

let Context = React.createContext();


let reducer = (state, action) => {
    Logger.log("received action");
    Logger.log(action);
    switch (action.type) {
        case "setEndDisplayName":
            return { ...state, endDisplayName: action.payload };
        case "setStartDisplayName":
            return { ...state, startDisplayName: action.payload };
        case "setStartOnMap":
            return { ...state, startPosition: action.payload };
        case "setEndOnMap":
            return { ...state, endPosition: action.payload };
        case "receivedItineraries":
            return {
                ...state,
                itineraries: action.payload,
                selectedItineraryId: undefined
            };
        case "selectIti":
            return {
                ...state,
                selectedItineraryId: action.payload,
                selectedLegIndex: undefined,
                selectedStepIndex: undefined
            };
        case "itiLegDetails":
            return { ...state, selectedLegIndex: action.payload, selectedStepIndex: undefined };
        case "selectStep":
            return { ...state, selectedStepIndex: action.payload };
        case "setAppState":
            return { ...state, appState: action.payload };
        case "loadColors":
            return { ...state, colors: action.payload };
        case "loadConfig":
            return { ...state, config: action.payload };
        case "changeDefaultMapCenter":
            return { ...state, mapDefaultCenter: action.payload };
        case "mouseOverLeg": {
            if (state.highlightLeg !== action.payload)
                return { ...state, highlightLeg: action.payload }
        }
        case "loadElectricConfig":
            return { ...state, electricConfig: action.payload };
        case "loadChargerPlugTypeConfig":
            return { ...state, electricPlugTypeConfig: action.payload };
        case "temperatures":
            return { ...state, temperatures: action.payload };
        case "loadedOperators":
            return { ...state, operators: action.payload };
        case "loadedStations":
            return { ...state, stations: action.payload };
        case "loadMetadata":
            return { ...state, metadata: action.payload };
        case "setLayoutSize":
            return { ...state, layoutSize: action.payload };
        case "clearAreaData":
            return { ...state, operators: undefined, stations: undefined, electricConfig:undefined, loadMetadata:undefined };
        case "updateQuery":

            return { ...state, query: action.payload };
        default:
            Logger.log("Unknown action, doing nothing")
    }
}

function ContextProvider(props) {
    let [state, dispatch] = React.useReducer(reducer, { appState: "s", query: def.query });// Initial state goes here
    let value = { state, dispatch }

    return <Context.Provider value={value}>{props.children}</Context.Provider>
}


let ContextConsumer = Context.Consumer;

export { Context, ContextProvider, ContextConsumer };

